import {
  SUBJECT_ID_A2ENGLISH,
  SUBJECT_ID_AMATH,
  SUBJECT_ID_B1ENGLISH,
  SUBJECT_ID_B2ENGLISH,
  SUBJECT_ID_BIOLOGY,
  SUBJECT_ID_BIOLOGY_O_LEVEL,
  SUBJECT_ID_CHEMISTRY,
  SUBJECT_ID_CHEMISTRY_O_LEVEL,
  SUBJECT_ID_CHINESE,
  SUBJECT_ID_CHINESE_2,
  SUBJECT_ID_CHINESE_3,
  SUBJECT_ID_CHINESE_4,
  SUBJECT_ID_CHINESE_ADD_ON,
  SUBJECT_ID_CSCHEMISTRY,
  SUBJECT_ID_CSCHEMISTRY_NA_LEVEL,
  SUBJECT_ID_CSCHEMISTRY_O_LEVEL,
  SUBJECT_ID_CSCHEMISTRYNA,
  SUBJECT_ID_CSPHYSICS,
  SUBJECT_ID_CSPHYSICS_NA_LEVEL,
  SUBJECT_ID_CSPHYSICS_O_LEVEL,
  SUBJECT_ID_CSPHYSICSNA,
  SUBJECT_ID_EMATH,
  SUBJECT_ID_ENGLISH,
  SUBJECT_ID_FOUNDATION_MATH,
  SUBJECT_ID_GENIUM_ENGLISH,
  SUBJECT_ID_GENIUM_MATHEMATICS,
  SUBJECT_ID_MATH,
  SUBJECT_ID_PHYSICS,
  SUBJECT_ID_PHYSICS_O_LEVEL,
  SUBJECT_ID_SCIENCE,
  SUBJECT_ID_VIETNAM_MATH,
  SUBJECT_ID_YLE,
} from '@utils/constants/subject.constants';

export function subjectRouteFromId(subjectId: number): string {
  let subject_route = '';
  switch (subjectId) {
    case 1:
      subject_route = 'english';
      break;
    case 2:
      subject_route = 'mathematics';
      break;
    case 3:
      subject_route = 'science';
      break;
    case 4:
      subject_route = 'chinese';
      break;
    case 5:
      subject_route = 'malay';
      break;
    case 6:
      subject_route = 'tamil';
      break;
    case 7:
      subject_route = 'e-math';
      break;
    case 8:
      subject_route = 'a-math';
      break;
    case 9:
      subject_route = 'physics-old';
      break;
    case 10:
      subject_route = 'chemistry-old';
      break;
    case 11:
      subject_route = 'biology-old';
      break;
    case 15:
      subject_route = 'h2-math';
      break;
    case 18:
      subject_route = 'h2-physics';
      break;
    case 19:
      subject_route = 'chinese-c2';
      break;
    case 24:
      subject_route = 'combined-science-physics';
      break;
    case 25:
      subject_route = 'foundation-mathematics';
      break;
    case 26:
      subject_route = 'young-learners-english';
      break;
    case 27:
      subject_route = 'vietnam-mathematics';
      break;
    case 28:
      subject_route = 'combined-science-chemistry';
      break;
    case 29:
      subject_route = 'combined-science-physics-na';
      break;
    case 30:
      subject_route = 'combined-science-chemistry-na';
      break;
    case 35:
      subject_route = 'chemistry';
      break;
    case 36:
      subject_route = 'physics';
      break;
    case 37:
      subject_route = 'combined-chemistry-o-level';
      break;
    case 38:
      subject_route = 'combined-physics-o-level';
      break;
    case 39:
      subject_route = 'combined-chemistry-na-level';
      break;
    case 40:
      subject_route = 'combined-physics-na-level';
      break;
    case 42:
      subject_route = 'biology';
      break;
    case 51:
      subject_route = 'tss-practice';
      break;
    case 54:
      subject_route = 'h2-chemistry';
      break;
    case 55:
      subject_route = 'h2-biology';
      break;
    case 56:
      subject_route = 'english-psle';
      break;
    case 57:
      subject_route = 'psle-camp';
      break;
  }
  return subject_route;
}

export function subjectIdFromName(subjectName: string | undefined): number {
  let subject_id = 0;
  switch (subjectName) {
    case 'english':
      subject_id = 1;
      break;
    case 'mathematics':
      subject_id = 2;
      break;
    case 'science':
      subject_id = 3;
      break;
    case 'chinese':
      subject_id = 4;
      break;
    case 'malay':
      subject_id = 5;
      break;
    case 'tamil':
      subject_id = 6;
      break;
    case 'e-math':
      subject_id = 7;
      break;
    case 'a-math':
      subject_id = 8;
      break;
    case 'physics-old':
      subject_id = 9;
      break;
    case 'chemistry-old':
      subject_id = 10;
      break;
    case 'biology-old':
      subject_id = 11;
      break;
    case 'h2-math':
      subject_id = 15;
      break;
    case 'h2-physics':
      subject_id = 18;
      break;
    case 'chinese-c2':
      subject_id = 19;
      break;
    case 'combined-science-physics':
      subject_id = 24;
      break;
    case 'foundation-mathematics':
      subject_id = 25;
      break;
    case 'young-learners-english':
      subject_id = 26;
      break;
    case 'vietnam-mathematics':
      subject_id = 27;
      break;
    case 'combined-science-chemistry':
      subject_id = 28;
      break;
    case 'combined-science-physics-na':
      subject_id = 29;
      break;
    case 'combined-science-chemistry-na':
      subject_id = 30;
      break;
    case 'chemistry':
      subject_id = 35;
      break;
    case 'physics':
      subject_id = 36;
      break;
    case 'combined-chemistry-o-level':
      subject_id = 37;
      break;
    case 'combined-physics-o-level':
      subject_id = 38;
      break;
    case 'combined-chemistry-na-level':
      subject_id = 39;
      break;
    case 'combined-physics-na-level':
      subject_id = 40;
      break;
    case 'biology':
    case 'biology-new-syllabus':
      subject_id = 42;
      break;
    case 'tss-practice':
      subject_id = 51;
      break;
    case 'h2-chemistry':
      subject_id = 54;
      break;
    case 'h2-biology':
      subject_id = 55;
      break;
    case 'english-psle':
      subject_id = 56;
      break;
    case 'psle-camp':
      subject_id = 57;
      break;
  }
  return subject_id;
}

export function subjectDisplayNameFromSlug(subjectSlug: string): string {
  let subjectDisplay = '';
  switch (subjectSlug) {
    case 'english':
      subjectDisplay = 'English';
      break;
    case 'mathematics':
      subjectDisplay = 'Mathematics';
      break;
    case 'science':
      subjectDisplay = 'Science';
      break;
    case 'chinese':
      subjectDisplay = 'Chinese';
      break;
    case 'malay':
      subjectDisplay = 'Malay';
      break;
    case 'tamil':
      subjectDisplay = 'Tamil';
      break;
    case 'e-math':
      subjectDisplay = 'E math';
      break;
    case 'a-math':
      subjectDisplay = 'A math';
      break;
    case 'physics-old':
      subjectDisplay = 'Physics (old)';
      break;
    case 'chemistry-old':
      subjectDisplay = 'Chemistry (old)';
      break;
    case 'biology-old':
      subjectDisplay = 'Biology (old)';
      break;
    case 'biology':
      subjectDisplay = 'Biology';
      break;
    case 'h2-math':
      subjectDisplay = 'H2 Mathematics';
      break;
    case 'h2-physics':
      subjectDisplay = 'H2 Physics';
      break;
    case 'chinese-c2':
      subjectDisplay = 'Chinese 华文';
      break;
    case 'combined-science-physics':
      subjectDisplay = 'Combined science physics';
      break;
    case 'foundation-mathematics':
      subjectDisplay = 'Foundation mathematics';
      break;
    case 'young-learners-english':
      subjectDisplay = "Young Learner's English";
      break;
    case 'vietnam-mathematics':
      subjectDisplay = 'Vietnam mathematics';
      break;
    case 'combined-science-chemistry':
      subjectDisplay = 'Combined science chemistry';
      break;
    case 'combined-science-physics-na':
      subjectDisplay = 'Combined science physics na level';
      break;
    case 'combined-science-chemistry-na':
      subjectDisplay = 'Combined science chemistry na level';
      break;
    case 'chemistry':
      subjectDisplay = 'Chemistry';
      break;
    case 'physics':
      subjectDisplay = 'Physics';
      break;
    case 'combined-chemistry-o-level':
      subjectDisplay = 'Combined chemistry O level';
      break;
    case 'combined-physics-o-level':
      subjectDisplay = 'Combined physics O level';
      break;
    case 'combined-chemistry-na-level':
      subjectDisplay = 'Combined chemistry na level';
      break;
    case 'combined-physics-na-level':
      subjectDisplay = 'Combined physics na level';
      break;
    case 'tss-practice':
      subjectDisplay = 'TSS Practice';
      break;
    case 'h2-chemistry':
      subjectDisplay = 'H2 Chemistry';
      break;
    case 'h2-biology':
      subjectDisplay = 'H2 Biology';
      break;
    case 'english-psle':
      subjectDisplay = 'English PSLE';
      break;
    case 'psle-camp':
      subjectDisplay = 'PSLE Camp';
      break;
  }

  if (!subjectDisplay) {
    subjectDisplay = subjectSlug.replace(',', ' ');
    subjectDisplay =
      subjectDisplay.charAt(0).toUpperCase() + subjectDisplay.slice(1);
  }
  return subjectDisplay;
}

export function subjectCategoryFromId(id: number) {
  switch (id) {
    case SUBJECT_ID_ENGLISH:
    case SUBJECT_ID_YLE:
    case SUBJECT_ID_A2ENGLISH:
    case SUBJECT_ID_B1ENGLISH:
    case SUBJECT_ID_B2ENGLISH:
    case SUBJECT_ID_GENIUM_ENGLISH:
      return 'english';
    case SUBJECT_ID_SCIENCE:
    case SUBJECT_ID_PHYSICS:
    case SUBJECT_ID_CHEMISTRY:
    case SUBJECT_ID_BIOLOGY:
    case SUBJECT_ID_BIOLOGY_O_LEVEL:
    case SUBJECT_ID_CSPHYSICS:
    case SUBJECT_ID_CSCHEMISTRY:
    case SUBJECT_ID_CSPHYSICSNA:
    case SUBJECT_ID_CSCHEMISTRYNA:
    case SUBJECT_ID_CHEMISTRY_O_LEVEL:
    case SUBJECT_ID_PHYSICS_O_LEVEL:
    case SUBJECT_ID_CSCHEMISTRY_O_LEVEL:
    case SUBJECT_ID_CSPHYSICS_O_LEVEL:
    case SUBJECT_ID_CSCHEMISTRY_NA_LEVEL:
    case SUBJECT_ID_CSPHYSICS_NA_LEVEL:
      return 'science';
    case SUBJECT_ID_CHINESE:
    case SUBJECT_ID_CHINESE_2:
    case SUBJECT_ID_CHINESE_3:
    case SUBJECT_ID_CHINESE_4:
    case SUBJECT_ID_CHINESE_ADD_ON:
      return 'chinese';
    case SUBJECT_ID_AMATH:
    case SUBJECT_ID_MATH:
    case SUBJECT_ID_EMATH:
    case SUBJECT_ID_FOUNDATION_MATH:
    case SUBJECT_ID_VIETNAM_MATH:
    case SUBJECT_ID_GENIUM_MATHEMATICS:
      return 'math';
    default:
      return 'math';
  }
}
